import { styled } from '@mui/material/styles';
import Progress from './Progress';
import Overlay from './Overlay';

interface FullscreenProgressProps {
  isVisible: boolean;
}

const SpinnerContainer = styled('div')`
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: ${(p) => p.theme.zIndex.modal - 1};
`;

const FullscreenProgress = ({ isVisible }: FullscreenProgressProps) => {
  return (
    <>
      <Overlay isVisible={isVisible} />
      {isVisible && (
        <SpinnerContainer>
          <Progress isVisible={isVisible} />
        </SpinnerContainer>
      )}
    </>
  );
};

export default FullscreenProgress;
